import React, { useEffect, useState } from 'react';
const Konva = require('konva');

import GraphicSidebarText from '../../components/properties/GraphicPropertiesText/GraphicPropertiesText';
import GraphicSidebarImage from '../../components/properties/GraphicPropertiesImage/GraphicPropertiesImage';
import GraphicSidebarGroup from '../../components/properties/GraphicPropertiesGroup/GraphicPropertiesGroup';
import GraphicSidebarRect from '../../components/properties/GraphicPropertiesRect/GraphicPropertiesRect';
import GraphicSidebarStar from '../../components/properties/GraphicPropertiesStar/GraphicPropertiesStar';
import GraphicSidebarEllipse from '../../components/properties/GraphicPropertiesEllipse/GraphicPropertiesEllipse';
import GraphicSidebarPolygon from '../../components/properties/GraphicPropertiesPolygon/GraphicPropertiesPolygon';
import GraphicSidebarLine from '../../components/properties/GraphicPropertiesLine/GraphicPropertiesLine';
import Header from '../../components/properties/PropertiesHeader/PropertiesHeader';
import Tab from '../../components/properties/PropertyTab/PropertyTab';

import usePropertiesStore from '../../stores/usePropertiesStore';

import styles from './GraphicProperties.module.css';

export default function (props) {
  const selectedGroup = usePropertiesStore((s) => s.selectedGroup);

  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    setActiveTab(1);
  }, [selectedGroup]);

  const tabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const getPropertiesContent = () => {
    if (!selectedGroup) return null;
    switch (selectedGroup.getAttr('elementType')) {
      case 'text':
        return (
          <GraphicSidebarText
            activeTab={activeTab}
            scaleText={props.scaleText}
            fonts={props.fonts}
            uploadFont={props.uploadFont}
          />
        );
      case 'image':
        return (
          <GraphicSidebarImage
            activeTab={activeTab}
            scaleImage={props.scaleImage}
            uploadFile={props.uploadFile}
            deleteImage={props.deleteImage}
          />
        );
      case 'group':
        if (selectedGroup instanceof Konva.Transformer) return null;
        return (
          <GraphicSidebarGroup
            activeTab={activeTab}
            scaleText={props.scaleText}
          />
        );
      case 'rect':
        return <GraphicSidebarRect activeTab={activeTab} />;
      case 'star':
        return <GraphicSidebarStar activeTab={activeTab} />;
      case 'ellipse':
        return <GraphicSidebarEllipse activeTab={activeTab} />;
      case 'polygon':
        return <GraphicSidebarPolygon activeTab={activeTab} />;
      case 'line':
        return <GraphicSidebarLine activeTab={activeTab} />;
      default:
        return null;
    }
  };

  return (
    <aside className={styles.sidebar}>
      <div className={styles.headerBlock}>
        <Header onClose={props.onCloseProperties} caption='Properties' />
        <Tab activeTab={activeTab} setActiveTab={tabClick} />
      </div>
      {getPropertiesContent()}
    </aside>
  );
}
